module.exports = __webpack_public_path__ + "media/images/smart_ad_server_logo-870e3bf35e20d101e454c65d4d1852f5.png";